import { render, staticRenderFns } from "./EditSource.vue?vue&type=template&id=5080ece4"
import script from "./EditSource.vue?vue&type=script&lang=js"
export * from "./EditSource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports